import { TaskType } from "#/types/tickets";

export const TaskOptions = [
  { label: "taskOptions.sendingToMaintenance", value: TaskType.IN_MAINTENANCE },
  { label: "taskOptions.retrieval", value: TaskType.IN_RETRIEVAL },
  { label: "taskOptions.sendingToCustomers", value: TaskType.SENDING_TO_CUSTOMER },
  { label: "taskOptions.dispatchedToField", value: TaskType.DISPATCHED_TO_FIELD },
  { label: "taskOptions.dispatchedToSecondPlant", value: TaskType.DISPATCHED_TO_SECOND_PLANT },
];
